import React, { createContext, useContext, useState, useEffect } from 'react';
import en from './../../locales/en.json';
import ar from './../../locales/ar.json';

const LanguageContext = createContext();

export const useLanguage = () => useContext(LanguageContext);

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    const storedLanguage = localStorage.getItem('language');
    return storedLanguage ? storedLanguage : 'English';
  });

  const translations = language === 'Arabic' ? ar : en;
  const direction =  language === 'Arabic' ? 'rtl' : 'ltr';

  useEffect(() => {
    localStorage.setItem('language', language);
  }, [language]);

  const toggleLanguage = () => {
    setLanguage((prev) => (prev === 'English' ? 'Arabic' : 'English'));
  };

  return (
    <LanguageContext.Provider value={{ translations, language, setLanguage, toggleLanguage, direction }}>
      {children}
    </LanguageContext.Provider>
  );
};
